import styled, { css } from "styled-components";
import * as UscMonthlyPriceDisclaimerStyles from "./UscMonthlyPriceDisclaimer.styles";

export const Wrapper = styled.div<{ inBasketDetailsModal?: boolean }>`
    display: flex;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-between;

    ${({ inBasketDetailsModal }) =>
        !inBasketDetailsModal &&
        css`
            &:not(:empty):not(:only-of-type) {
                margin-top: calc(var(--spacing-3) / 2);
            }
        `};

    ${UscMonthlyPriceDisclaimerStyles.MonthlyWrapper} {
        margin-top: 0;
    }
`;
